export default __webpack_public_path__ + "static/media/lieferheld_background_xl1.13212bd6.jpg";